import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-grid">
        <div>
          <Logo height={36} light />
          <p style={{ marginTop: '0.9rem', color: '#b9c4be', maxWidth: '32ch' }}>
            Your friendly local laundry & dry cleaning service. We collect, clean and
            deliver — so you get your weekends back.
          </p>
        </div>

        <div>
          <h4>Company</h4>
          <Link to="/pricing">Pricing</Link>
          <Link to="/about">About us</Link>
          <Link to="/faq">FAQ</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div>
          <h4>Get in touch</h4>
          <a href="tel:+440000000000">Call us</a>
          <a href="mailto:hello@venividilaundry.co.uk">hello@venividilaundry.co.uk</a>
          <span style={{ color: '#b9c4be', display: 'block', marginTop: '0.4rem' }}>
            SW &amp; Central London · Heathrow · Staines · Weybridge
          </span>
        </div>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Veni Vidi Laundry. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
